import { MoneyFromCents } from '@libs/services/money';

export const TotalWithTaxFooter = ({
  subtotalInCents,
  taxAmountInCents,
  totalInCents,
  isCalculatingTaxes = false,
}: {
  subtotalInCents: number;
  taxAmountInCents: number;
  totalInCents: number;
  isCalculatingTaxes?: boolean;
}) => {
  return (
    <div>
      <div className="flex flex-col gap-2 bg-slate-100 rounded-lg px-4 py-2 mt-2  ">
        <div className="flex flex-row w-full justify-between text-sm">
          <p>Subtotal</p>
          <p>{MoneyFromCents(subtotalInCents || 0).toFormat()}</p>
        </div>
        <div className="flex flex-row w-full justify-between text-sm">
          <p>Tax</p>
          <p>
            {isCalculatingTaxes
              ? 'Calculating...'
              : MoneyFromCents(taxAmountInCents || 0).toFormat()}
          </p>
        </div>
      </div>
      <div className="bg-slate-800 px-4 py-3 rounded-b-lg">
        <div className="flex flex-row justify-between w-full">
          <p className="flex flex-row gap-2 items-center text-white font-bold">Total</p>
          <p className="font-bold text-white">
            {isCalculatingTaxes ? 'Calculating...' : MoneyFromCents(totalInCents || 0).toFormat()}
          </p>
        </div>
      </div>
    </div>
  );
};
